module.exports = __webpack_public_path__ + "static/media/TermsOfServicePage.15d07b59.jpeg";